//DOM Ready

async function createDraftOrder(data) {
  try {
    if (data?.lineItems?.length) {
      const body = JSON.stringify(data);
      const response = await fetch(`${window.appDomain}/draft-order/create`, {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body,
      });
      const responseData = await response.json();
      if (!response.ok) {
        if (response.status === 401) {
          window.location.href = "/account/login";
          return;
        } else {
          throw new Error(responseData.message);
        }
      }

      if (responseData?.data?.invoice_url) {
        window.location.href = responseData.data.invoice_url;
      } else {
        throw new Error("注文を作成できませんでした");
      }
    }
  } catch (error) {
    alert(error.message);
  } finally {
    hideLoading();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const formCart = document.querySelector("form#cart");
  if (!formCart) return;
  $("form#cart").on("submit", (e) => {
    showLoading();

    const { customerId, loggedIn, cartStatus } = formCart.dataset;
    if (customerId) {
      const lineItems = getCartItems();
      const defaultAddressId = $("#default_address_id").val() ?? null;
      const shippingAddressId =
        $("#delivery_address option:selected").val() ?? null;
      const deliveryTime = $("#delivery_time option:selected").val() || null;
      const note = $("#Cart-note").val() || null;
      if (["subscription", "normal"].includes(cartStatus)) {
        let noteAttribute = {
          delivery_time: deliveryTime,
          default_address_id: defaultAddressId,
          shipping_address_id: shippingAddressId,
          is_logged_in: loggedIn,
        };
        let noteText = "";
        if (deliveryTime && deliveryTime.trim() !== "") {
          noteText = `配達時間: ${deliveryTime}`;
        }
        if (note && note.trim() !== "") {
          noteText = `${noteText}\nメモ: ${note}`;
        }
        noteText = `${noteText}\n\n\n\n\n----------\n${JSON.stringify(noteAttribute)}`;

        $('textarea[name="note"]').val(noteText);
        return;
      }

      e.preventDefault();

      const draftOrderData = {
        lineItems,
        customerId,
        defaultAddressId,
        shippingAddressId,
        loggedIn,
        cartType: cartStatus,
        deliveryTime,
        note,
      };

      return createDraftOrder(draftOrderData);
    } else {
      e.preventDefault(); // Prevent the default form submission behavior
      window.location.href = "/account/login?returnUrl=/cart";
    }
  });
});

function preventSubmitCart(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    const quantityInput = event.target;
    quantityInput.blur();
    var cartItems = new CartItems();
    cartItems.onChange(event);
  }
}

function showLoading() {
  const submitButton = $('button[form="cart"][type="submit"]');
  const loadingSpinner = $(".loading__spinner", submitButton);
  if (loadingSpinner) {
    submitButton.addClass("loading");
    submitButton.attr("disabled", true);
    loadingSpinner.removeClass("hidden");
  }
}

function hideLoading() {
  const submitButton = $('button[form="cart"][type="submit"]');
  const loadingSpinner = $(".loading__spinner", submitButton);
  if (loadingSpinner) {
    submitButton.removeClass("loading");
    submitButton.attr("disabled", false);
    loadingSpinner.addClass("hidden");
  }
}
